export default "__VITE_ASSET__BUkFCorb__"